import React from "react"
import { Alert, Snackbar } from "@mui/material"

import "./toast.scss"

const Toast = ({ open, onClose, severity, message }) => {
  const duration = severity === "error" ? 30000 : 10000

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        severity={severity}
        onClose={onClose}
        style={{
          maxHeight: 100,
          overflowY: "auto",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {/*
          El caso "warning" asumia que message siempre era un arreglo, asi que
          un setWarnings("texto") rompia el render con
          "message.map is not a function". Ahora se decide por el tipo del
          dato y no por la severidad: un arreglo se lista, un string se
          muestra tal cual, sin importar si es error, success o warning.
        */}
        {Array.isArray(message)
          ? message.map((item, i) => <div key={i}>{item}</div>)
          : message}
      </Alert>
    </Snackbar>
  )
}

export default Toast
